// @flow

"use strict";

import Constants from "../constants/constants";

/**
 * URLクエリパラメータユーティリティクラス
 */
export default class URLParamUtil {

  /**
   * クエリパラメータから指定したkeyの値を取得
   * @param window
   * @param paramKey
   * @returns {string}
   */
  static getURLParamByKey(window: Window, paramKey: string): string {
    let ret = "";

    const params = window.location.search.substring(1).split('&');
    for(let i = 0; i < params.length; i++) {
      const keySearch = params[i].search(/=/);

      let key = '';
      if(keySearch != -1) {
        key = params[i].slice(0, keySearch);
      }

      if(key != '' && key === paramKey) {
        ret = params[i].slice(params[i].indexOf('=', 0) + 1);
        break;
      }
    }
    return ret;
  }

  /**
   * ウィジェットが表示されている記事のクエリパラメータにuzou_debug=1がついている場合リハーサル配信とする
   * リハーサル配信 = placement.status = 0でもウィジェット表示、impressionを発生させない
   * @param window
   * @returns {boolean}
   */
  static isRehearsal(window: Window): boolean {
    return URLParamUtil.getURLParamByKey(window.top, Constants.uzouDebugURLParamKey) === Constants.uzouDebugURLParam;
  }

  /**
   * uzou_debug=1文字列を返す。
   * @returns {string}
   */
  static getUzouDebugQuery(): string {
    return `${Constants.uzouDebugURLParamKey}=${Constants.uzouDebugURLParam}`;
  }
}


// WEBPACK FOOTER //
// ./src/js/util/url-param-util.js